import React from 'react';
import './Backup_products.css';
import { Link } from 'react-router-dom'; // Needed if you're using React Router

const products = [
     { image: '/Assets/ProductGrid_Iamges/Arcline-Blinds.jpg', name: 'ARCLINE BLINDS', link: '/products/arcline-blinds' },
    { image: '/Assets/ProductGrid_Iamges/01-Roller-Blinds.webp', name: 'ROLLER BLINDS', link: '/products/roller-blinds' },
    { image: '/Assets/ProductGrid_Iamges/02Roman.webp', name: 'ROMAN BLINDS', link: '/products/roman-blinds' },
    { image: '/Assets/ProductGrid_Iamges/luzon-.webp', name: 'LUZON BLINDS', link: '/products/luzon-blinds' },
    { image: '/Assets/ProductGrid_Iamges/05Wooden-Venetian-1.webp', name: 'WOODEN - VENETIAN BLINDS', link: '/products/wooden-venetian-blinds' },
    { image: '/Assets/ProductGrid_Iamges/12Printed-1.webp', name: 'PRINTED BLINDS', link: '/printed-blinds' },
    { image: '/Assets/ProductGrid_Iamges/07Skylight-1.webp', name: 'SKYLIGHT BLINDS', link: '/products/skylight-blinds' },
    { image: '/Assets/ProductGrid_Iamges/01colby.webp', name: 'COLBY BLINDS', link: '/products/colby-blinds' },
    { image: '/Assets/ProductGrid_Iamges/17Automation.webp', name: 'AUTOMATION', link: '/automation' },
    { image: '/Assets/ProductGrid_Iamges/09Sierra.webp', name: 'SIERRA BLINDS', link: '/products/sierra-blinds' },
    { image: '/Assets/ProductGrid_Iamges/08Panel-1.webp', name: 'PANEL BLINDS', link: '/products/panel-blinds' },
    { image: '/Assets/ProductGrid_Iamges/03Grayson.webp', name: 'GRAYSON BLINDS', link: '/products/grayson-blinds' },
    { image: '/Assets/ProductGrid_Iamges/01-meliso-blinds-scaled.webp', name: 'MELISO BLINDS', link: '/products/meliso-blinds' },
    { image: '/Assets/ProductGrid_Iamges/16Eton.webp', name: 'ETON BLINDS', link: '/products/eton-blinds' },
    { image: '/Assets/ProductGrid_Iamges/02-patricia-blinds-scaled.webp', name: 'PATRICIA BLINDS', link: '/products/patricia-blinds' },
    { image: '/Assets/ProductGrid_Iamges/13Dorren.webp', name: 'DORREN BLINDS', link: '/products/dorren-blinds' },
    { image: '/Assets/ProductGrid_Iamges/15Vertical-1.webp', name: 'VERTICAL BLINDS', link: '/products/vertical-blinds' },
];

const ProductGrid = () => {
    return (
        <section className="Product_Page-Grid">
            <div className="product-Grid">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Products</h1>
                    <p className="Page_Subtitle-Dark">Discover our stunning array of window Covering Fashion where style meets luxury</p>
                </div>


                <div className="grid-container">
                    <div className="section-header">
                        <p><strong>Marvel Window Covering Products</strong> are customized. We design & assemble our blinds to accuracy with variety of fabrics, designs and operating systems. Our commitment to quality and innovation gives our customers freedom to select from wide range of features, fabrics, colours and operating systems.</p>
                    </div>
                    {products.map((product, index) => (
                        <Link to={`${product.link}`} key={index} className="product-card">
                            <div className="product-name">{product.name}</div>
                            <img src={product.image} alt={product.name} className="product-image" />
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProductGrid;
